import React, { useState, useRef, useEffect } from 'react';
import L from 'leaflet';
import {
  IoIosClose,
  IoIosAdd,
  IoIosRemove,
  IoIosArrowUp,
  IoIosArrowDown,
} from 'react-icons/io';
import { useMap } from 'react-leaflet/hooks';
import { useSelector } from 'react-redux';
import '../styles/listview.css';
import token_dict from '../data/token_dict.json';
import ownership_full from '../data/availability_list.json';
import { Alchemy, Network } from 'alchemy-sdk';
import contract from './redux/config/config.json';
import { selectQueried } from './MyMap.js';
import { IoCopyOutline, IoOpenOutline } from 'react-icons/io5';

const contractABI = require('./contract-abi.json');
const { createAlchemyWeb3 } = require('@alch/alchemy-web3');

var alch_network;
var alch_key;
var alchemyKey;
var contractAddress;
var opensea_key;

if (contract.NETWORK.ID == 1) {
  // Initialization
  alch_key = contract.ALCH_KEY;
  alch_network = Network.ETH_MAINNET;
  alchemyKey = contract.ALCH_KEY_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS);
  opensea_key = contract.OPENSEA_KEY;
}
if (contract.NETWORK.ID == 5) {
  // Initialization
  alch_key = contract.ALCH_KEY_TEST;
  alch_network = "eth-sepolia"; //Network.ETH_SEPOLIA;
  alchemyKey = contract.ALCH_KEY_TEST_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  opensea_key = contract.OPENSEA_KEY;
}

const alc_config = {
  apiKey: alch_key,
  network: alch_network,
};
const alchemy = new Alchemy(alc_config);
const alch_web3 = createAlchemyWeb3(alchemyKey);

let arr = [];
for (let i = 0; i < 1000; i++) {
  arr.push(i);
}

const TileSlider = ({ onChange }) => {
  const [value, setValue] = useState([0, 67]);

  const handleClick = (e) => {
    if (e.target.className !== 'rc-slider-handle') {
      e.stopPropagation();
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    onChange(newValue); // Call the onChange prop with the new value
  };

  const handleMinChange = (event) => {
    const newValue = Number(event.target.value);
    if (newValue <= value[1]) {
      setValue([newValue, value[1]]);
      onChange([newValue, value[1]]);
    }
  };

  const handleMaxChange = (event) => {
    const newValue = Number(event.target.value);
    if (newValue >= value[0]) {
      setValue([value[0], newValue]);
      onChange([value[0], newValue]);
    }
  };

  return (
    <div className="filter-ref" onClick={handleClick}>
      <input
        type="number"
        min={0}
        max={67}
        value={value[0]}
        onChange={handleMinChange}
      />
      <span style={{ fontSize: 20 }}>-</span>
      <input
        type="number"
        min={0}
        max={67}
        value={value[1]}
        onChange={handleMaxChange}
      />
    </div>
  );
};

/*
    <div className="filter-options" style={{ paddingBottom: "10px"}}>
        <span style={{ color: 'rgba(255,255,255,0.8)'}}>Cheapest pixel listed: {ppFloor}</span><br></br>
        <span style={{ color: 'rgba(255,255,255,0.8)'}}>Mint pixel price: 0.00000025</span>
      </div>
    */

export const ListView = ({
  gridOverlay,
  setMasterTile,
  setSidebarTitle,
  listView,
  setListView,
  ownershipUpdated,
  setSidebar,
  masterTile,
  setCurrentPrompt,
  setTilePreview,
  setlistViewExpanded,
  setProjectInfo,
  ownership,
  setOwnership,
}) => {
  const map = useMap();
  const blockchain = useSelector((state) => state.blockchain);
  const [selectedItem, setSelectedItem] = useState(null);
  const [mousedOverItem, setMousedOverItem] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [tileRange, setTileRange] = useState({ min: 0, max: 67 });
  const [filtersOpened, setFiltersOpened] = useState(1);
  const listViewRef = useRef(null);
  const [items, setItems] = useState([]);
  const [listedTokens, setListedTokens] = useState([]);
  const [listedTokensPrices, setListedTokensPrices] = useState({});
  const [ppFloor, setppFloor] = useState(null);
  const [ppFloorToken, setppFloorToken] = useState(null);
  const [sortAscending, setSortAscending] = useState(true);
  const [sortListedPrice, setSortListedPrice] = useState(false);

  const selectQueriedClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    queryNumObject,
    setTilePreview
  }) =>
    selectQueried({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      queryNumObject,
      setTilePreview
    });

  function setLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://opensea.io/assets/ethereum/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://testnets.opensea.io/assets/goerli/';
    }
    let link_with_contract = link_base.concat(String(contractAddress));
    let link2 = link_with_contract.concat('/');
    let full_link = link2.concat(curTile);
    return full_link;
  }

  async function getMintPrice(tokenId) {
      return (Number(tokenId) * 250000000000) / 1000000000000000000;
  }

  async function fetchItems() {
    const promises = arr.map(async (num) => {
      let num_padded = num.toString().padStart(4, '0');
      let price = await getMintPrice(token_dict[num_padded]);
      var listedPrice = null;
      if (listedTokens.includes(token_dict[num_padded].toString())) {
        listedPrice = listedTokensPrices[token_dict[num_padded].toString()];
      } else if (ownership[token_dict[num_padded]] !== 0) {
        listedPrice = null;
      }
      let status =
        ownership[token_dict[num_padded]] === 0
          ? 'Unminted'
          : ownership[token_dict[num_padded]] === 1
          ? 'Minted'
          : ownership[token_dict[num_padded]] === 2
          ? 'Yours'
          : ownership[token_dict[num_padded]] === 3
          ? 'Listed'
          : 'Unknown';
      return (selectedStatus === 'All' ||
        selectedStatus === status ||
        (selectedStatus === 'Listed' &&
          listedTokens.includes(token_dict[num_padded].toString())) ||
        (selectedStatus === 'Minted' && status === 'Yours')) &&
        ((price >= tileRange.min &&
          price <= tileRange.max &&
          !sortListedPrice) ||
          (listedPrice * token_dict[num_padded] >= tileRange.min &&
            listedPrice * token_dict[num_padded] <= tileRange.max &&
            sortListedPrice))
        ? {
            image: `https://www.latentculture.com/tohm/thumbs/TODEM.thumb.${num_padded}.jpg`,
            name: num_padded,
            price: price.toFixed(5),
            listedPrice: listedPrice,
            status: status,
          }
        : null;
    });

    let items = (await Promise.all(promises)).filter((item) => item !== null);
    //items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name)); // Sort items
    if (sortListedPrice && selectedStatus === 'Listed') {
      items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name));
      items.sort((a, b) =>
        sortAscending
          ? a.listedPrice * token_dict[a.name] -
            b.listedPrice * token_dict[b.name]
          : b.listedPrice * token_dict[b.name] -
            a.listedPrice * token_dict[a.name]
      );
    } else {
      items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name));
    }

    setItems(items);
  }

  async function fetchPixelPrice() {
    const url = 'https://api.opensea.io/v2/listings/collection/todem/all';
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'X-API-KEY': opensea_key,
      },
    };
    let listings;
    await fetch(url, options)
      .then((res) => res.json())
      .then((json) => (listings = json.listings));

    const PixelPrices = [];
    const ListedTokens = [];
    const ListedTokensAndPrices = {};
    for (let listing of listings) {
      let listedPrice =
        listing.price.current.value / 10 ** listing.price.current.decimals;
      let listedTokenArea =
        listing.protocol_data.parameters.offer[0].identifierOrCriteria;
      PixelPrices.push(listedPrice / listedTokenArea);
      ListedTokens.push(listedTokenArea);
      ListedTokensAndPrices[listedTokenArea] = listedPrice / listedTokenArea;
      //for (let key in token_dict) {
      //   if (token_dict[key] == listedTokenArea) {
      //     ownership[token_dict[key]] = 3
      //   }
      //}
    }
    setListedTokens(ListedTokens);
    setListedTokensPrices(ListedTokensAndPrices);
    let tempPPFloor = Math.min(...PixelPrices);
    setppFloor(tempPPFloor.toFixed(8));
    let floorTokenID = Object.keys(ListedTokensAndPrices).find(
      (key) => ListedTokensAndPrices[key] == tempPPFloor
    ); //ListedTokens[PixelPrices.indexOf(tempPPFloor)]
    let floorTokenNum = Object.keys(token_dict).find(
      (key) => token_dict[key] == floorTokenID
    );
    setppFloorToken(floorTokenID);
    //console.log(Math.min(...PixelPrices))
  }

  useEffect(() => {
    fetchPixelPrice();
  }, [masterTile]);

  useEffect(() => {
    if (selectedItem != masterTile.masterTile.name.split('-')[1]) {
      setSelectedItem(null);
    }
  }, [masterTile]);

  useEffect(() => {
    if (selectedStatus == 'Listed') {
      setSortListedPrice(true);
    } else {
      setSortListedPrice(false);
    }
  }, [selectedStatus]);

  useEffect(() => {
    fetchItems();
  }, [
    ownership,
    ownershipUpdated,
    selectedStatus,
    tileRange,
    sortAscending,
    sortListedPrice,
  ]);

  useEffect(() => {
    L.DomEvent.disableClickPropagation(listViewRef.current);
    L.DomEvent.disableScrollPropagation(listViewRef.current);
  });

  return (
    <div
      className={
        listView ? 'list-view unselectable' : 'list-view hidden unselectable'
      }
      ref={listViewRef}
    >
      <div className="list-title">
        <div
          className="list-view-pop"
          style={{color:"#000000"
          }}
          onClick={() => {
            setProjectInfo(1);
            setlistViewExpanded(1);
          }}
        >
          <IoOpenOutline
            className="icon invert"
            style={{ color:"#000000", fontSize: 16, strokeWidth: 10,transform: "scaleX(-1)" }}
          />
          <span className="tooltiptext tooltiptext-pop">expand</span>
        </div>
        <span>Listview</span>
        <div
          className="list-view-close"
          onClick={() => {
            setListView(0);
          }}
        >
          <IoIosClose className="icon" style={{ fontSize: 25 }} />
        </div>
      </div>

      <div className={filtersOpened ? 'list-filter opened' : 'list-filter'}>
        <div className="filters-header">
          <span>Filters</span>

          <div
            className="clickable"
            onClick={() => {
              setFiltersOpened(!filtersOpened);
            }}
          >
            {filtersOpened ? (
              <IoIosRemove className="icon" style={{ fontSize: 25 }} />
            ) : (
              <IoIosAdd className="icon" style={{ fontSize: 25 }} />
            )}
          </div>
        </div>

        {filtersOpened ? (
          <div className="filter-options">
            <span style={{ color: 'rgba(255,255,255,0.8)' }}>Mint Status</span>
            <div className="radio-buttons">
              <label>
                <input
                  type="radio"
                  value="All"
                  checked={selectedStatus === 'All'}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  autoComplete="off"
                />
                All
              </label>
              <label>
                <input
                  type="radio"
                  value="Minted"
                  checked={selectedStatus === 'Minted'}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  autoComplete="off"
                />
                Minted
              </label>
              <label>
                <input
                  type="radio"
                  value="Unminted"
                  checked={selectedStatus === 'Unminted'}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  autoComplete="off"
                />
                Unminted
              </label>
              <label>
                <input
                  type="radio"
                  value="Yours"
                  checked={selectedStatus === 'Yours'}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  autoComplete="off"
                />
                Yours
              </label>
              <label>
                <input
                  type="radio"
                  value="Listed"
                  checked={selectedStatus === 'Listed'}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  autoComplete="off"
                />
                Listed
              </label>

              <img
                src="https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"
                alt="Opensea Icon"
                id="opensea"
                style={{
                  filter: 'grayscale(100%)',
                  opacity: 0.4,
                  pointerEvents: 'none',
                  margin: -60,
                  width: 16,
                  height: 16,
                }}
                onClick={() => {}}
              ></img>
            </div>
            <div
              style={{
                marginTop: 5,
                width: '100%',
                borderTop: 'rgba(154, 154, 154, 0.6) 1px solid',
                paddingTop: 7,
                paddingBottom: 7,
              }}
            >
              <span style={{ color: 'rgba(255,255,255,0.8)' }}>
                Price Range (eth)
              </span>
              <TileSlider
                value={[tileRange.min, tileRange.max]}
                onChange={(value) =>
                  setTileRange({ min: value[0], max: value[1] })
                }
              />
            </div>
          </div>
        ) : null}
      </div>

      <div className="tile-list">
        <div className="list-header">
          <span style={{ marginLeft: 75, color: '#9595ff' }}>
            Tile
          </span>
          <span
            style={{ marginLeft: 31, color: '#9595ff' }}
            onClick={() => {
              setSortListedPrice(!sortListedPrice);
            }}
          >
            {!(sortListedPrice && selectedStatus === 'Listed') ? (
              <>Mint</>
            ) : (
              <>List</>
            )}
            &nbsp;Price
          </span>
          <div
            className="icon  clickable"
            style={{
              pointerEvents: 'all',
              marginLeft: '10px',
              fontSize: 20,
              color: 'rgb(238, 238, 238)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
            onClick={() => {
              setSortAscending(!sortAscending);
            }}
          >
            {sortAscending ? (
              <IoIosArrowUp></IoIosArrowUp>
            ) : (
              <IoIosArrowDown></IoIosArrowDown>
            )}
          </div>
        </div>

        {ownershipUpdated ? (
          <>
            <div className="scrollable">
              {items.map((item, index) => (
                <div
                  className={`list-item clickable ${
                    item.name === selectedItem ? 'selected-list-item' : ''
                  }`}
                  style={{
                    backgroundColor:
                      ownership[token_dict[item.name]] === 1
                        ? 'rgb(148, 39, 39)'
                        : ownership[token_dict[item.name]] === 2
                        ? '#febe32'
                        : 'rgb(59, 49, 70)',
                    color:  ownership[token_dict[item.name]] === 2
                        ? "#000000"
                        : ownership[token_dict[item.name]] === 1
                        ? "#BEBEBE"
                        : "#BEBEBE",                       
                    // 'rgba(35, 38, 68)',
                    pointerEvents: 'all',
                    border:
                      item.name === mousedOverItem ? '1px solid #ffed7a' : null,
                  }}
                  key={item.name}
                  onMouseEnter={() => {
                    setMousedOverItem(item.name);
                  }}
                  onMouseLeave={() => {
                    setMousedOverItem(null);
                  }}
                  onClick={() => {
                    setSidebar(1);
                    setTilePreview(parseInt(item.name));
                    setCurrentPrompt(null);
                    selectQueriedClone({
                      map,
                      gridOverlay,
                      sidebarState: 0,
                      setMasterTile,
                      setSidebarTitle,
                      shouldZoom: 1,
                      queryNumObject: { number: item.name },
                      setTilePreview,
                    });
                    setSelectedItem(item.name);
                  }}
                >
                  <img src={item.image} className="item-image" />
                  <div className="item-name">{item.name}</div>
                  <div className="item-price">
                    {!(sortListedPrice && selectedStatus === 'Listed')
                      ? item.price
                      : item.listedPrice === null
                      ? '-'
                      : (item.listedPrice * token_dict[item.name]).toFixed(
                          5
                        )}{' '}
                    eth
                  </div>
                </div>
              ))}
            </div>
            <div className="list-footer">{items.length} of 1000 Tiles</div>
          </>
        ) : (
          <div className="loading-container">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
            >
              <rect
                className="spinner_9y7u"
                x="1"
                y="1"
                rx="1"
                width="10"
                height="10"
              />
              <rect
                className="spinner_9y7u spinner_DF2s"
                x="1"
                y="1"
                rx="1"
                width="10"
                height="10"
              />
              <rect
                className="spinner_9y7u spinner_q27e"
                x="1"
                y="1"
                rx="1"
                width="10"
                height="10"
              />
            </svg>
          </div>
        )}
      </div>
      <div className="filter-options" style={{ paddingBottom: '10px' }}>
        <span style={{ color: 'rgba(255,255,255,0.8)' }}>
          Mint per pixel:&nbsp;&nbsp;&nbsp;0.00000025
        </span>
        <br></br>
        <span style={{ color: 'rgba(255,255,255,0.8)' }}>
          Floor per pixel:&nbsp;&nbsp;
          <a
            className="ppFloorLink"
            style={{
              color: 'rgba(255,255,255,0.8)',
              textDecoration: 'underline',
            }}
            href={setLink(parseInt(ppFloorToken))}
            target="_blank"
          >
            {ppFloor}
          </a>
        </span>
      </div>
    </div>
  );
};

export default ListView;
